import { Toaster as Sonner, type ToasterProps } from "sonner";
import type { CSSProperties, JSX } from "react";

import { useTheme } from "@/components/theme";

/**
 * Site-local twin of the app's Toaster (src/renderer/src/components/ui/sonner).
 *
 * Not vendored through sync-app-components: the app reads its own theme store,
 * the website uses {@link useTheme}. The CSS-variable overrides below are copied
 * verbatim so a toast looks identical to the app's, and toast.ts (the
 * pop-on-repeat wrapper) is vendored.
 */
export const Toaster = (props: ToasterProps): JSX.Element => {
  const { resolved } = useTheme();
  return (
  <Sonner
    theme={resolved}
    richColors
    className="toaster group"
    style={
      {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)"
      } as CSSProperties
    }
    {...props}
  />
  );
};
